/**
 * ChatMessage Component
 *
 * Displays a single message in the agent chat interface.
 * Supports user messages, assistant messages, and error messages.
 */

import React from 'react';
import './ChatMessage.css';

const ChatMessage = ({ message }) => {
  const { role, content, timestamp, isError, dashboard_config } = message;

  const formatTimestamp = (isoString) => {
    if (!isoString) return '';
    const date = new Date(isoString);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className={`chat-message ${role} ${isError ? 'error' : ''}`}>
      <div className="message-header">
        <span className="message-role">
          {role === 'user' ? 'You' : 'Claude'}
        </span>
        <span className="message-timestamp">
          {formatTimestamp(timestamp)}
        </span>
      </div>
      <div className="message-content">
        {content}
      </div>
      {dashboard_config && (
        <div className="message-metadata">
          <span className="metadata-label">Generated:</span>
          <span className="metadata-value">{dashboard_config.title}</span>
          <span className="metadata-label">Template:</span>
          <span className="metadata-value">{dashboard_config.template_id}</span>
          <span className="metadata-label">Sections:</span>
          <span className="metadata-value">{dashboard_config.sections?.length || 0}</span>
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
